export default {
  hello: 'Salom',
  page: {
    example: 'Test str {name}'
  },
  other: 'Boshqa',
  searchByNameProduct: 'Taom nomi bo‘yicha qidiring',
  nothingFound: 'Hech narsa topilmadi',
  login: 'Kirish',
  password: 'Parol',
  chooseLanguage: 'Tilni tanlang',
  restaurantWifi: 'Restoran Wi-Fi',
  chipDialog: {
    gotIt: 'Tushundim',
    cashback: {
      title: 'Keshbek',
      description: 'Muassasada to‘lashda pul qaytarish.'
    },
    rating: {
      title: 'Reyting',
      description: 'Mehmonlar sharhlariga asoslangan baho.'
    },
    avgBill: {
      title: "O'rtacha chek",
      description: "Kishi boshiga o'rtacha buyurtma narxi."
    },
    workingHours: {
      title: 'Ish vaqti',
      description: 'Muassasa ish jadvali.'
    },
    address: {
      title: 'Manzil',
      description: 'Muassasa joylashuvi.'
    },
    openingHours: {
      title: 'Ish vaqti',
      description: 'Hozir ochiq yoki yopiqligi va qachon ochilishi yoki yopilishi.'
    },
    avgCooking: {
      title: 'Tayyorlash vaqti',
      description: 'Buyurtmalarni tayyorlashning taxminiy vaqti.'
    },
    venueInfo: {
      title: 'Muassasa haqida',
      description:
        'Muassasa haqida qisqacha maʼlumot. Batafsil uchun xodimlardan soʻrang.'
    }
  },
  venueInfoModal: {
    close: 'Yopish',
    scheduleMode: 'Ish rejimi',
    call: 'Qo‘ng‘iroq',
    route: 'Marshrut',
    taxi: 'Taksi',
    prep: 'Tayyorlash',
    delivery: 'Yetkazish',
    avgCheck: 'O‘rtacha chek',
    rating: 'Reyting',
    todaySuffix: ' (Bugun)',
    weekdays: {
      mon: 'Dushanba',
      tue: 'Seshanba',
      wed: 'Chorshanba',
      thu: 'Payshanba',
      fri: 'Juma',
      sat: 'Shanba',
      sun: 'Yakshanba'
    }
  },
  qrMenu: {
    passwordResetSuccessfully: 'Parol muvaffaqiyatli qayta tiklandi',
    unableToResetPassword: 'Parolni qayta tiklashda xatolik yuz berdi',
    shareText: 'Menyuni ko‘ring',
    openUntil: '{time} gacha ochiq',
    opensAt: '{time} da ochiladi',
    cookingMinutes: '{n} daqiqa',
    avgBillApprox: '~{amount} so‘m',
    menuLoadErrorTitle: 'Menyuni yuklab bo‘lmadi',
    sourceCart: 'Savatcha',
    sourceMenu: 'Menyu',
    orderLoadFailedTitle: 'Buyurtmani yuklab bo‘lmadi',
    orderPlaceFailedTitle: 'Buyurtma berib bo‘lmadi',
    yourOrder: 'Buyurtmangiz',
    yourLastOrder: "Buyurtmangizni ko'rish",
    dishNames: 'Taomlar',
    noOrderItems: 'Buyurtmada pozitsiyalar yo‘q',
    summaryInfo: 'Umumiy maʼlumot',
    orderSum: 'Buyurtma summasi',
    currencySuffix: 'so‘m',
    orderPriceItems: '{count} ta mahsulot',
    orderPriceAction: 'Buyurtma berish',
    backToHome: 'Bosh sahifaga qaytish',
    cartSectionAria: 'Savatcha',
    paymentSectionAria: 'To‘lov usuli',
    totalToPay: 'To‘lash uchun jami:',
    cartEmpty: 'Savatchangiz bo‘sh',
    authDialogTitle: 'Avtorizatsiya',
    storiesAlt: 'Storislar',
    back: 'Orqaga',
    orderUuidMissing: 'Buyurtma identifikatori ko‘rsatilmagan',
    orderLoadFailed: 'Buyurtmani yuklab bo‘lmadi',
    orderParseFailed: 'Buyurtma javobini tahlil qilib bo‘lmadi',
    tableOrderMissingTableId:
      'Stol havolasi yaroqsiz (stol ko‘rsatilmagan). Stol QR kodini qayta skanerlang.',
    orderErrorNoDetails:
      'Buyurtmani qayta ishlab bo‘lmadi. Qayta urinib ko‘ring yoki muassasa bilan bog‘laning.',
    orderTableProgress: {
      awaiting: 'Buyurtma yaratildi',
      awaiting_description: 'Restoran tasdiqini kutyapmiz',
      preparing: 'Restoran taomni tayyorlamoqda',
      preparing_description: 'Tez orada tayyor bo‘ladi',
      prepared: 'Taom tayyor',
      prepared_description: 'Kuryer tez orada olib ketadi',
      delivering: 'Kuryer yetkazmoqda',
      delivering_description: 'Tez orada joyida',
      ready: 'Buyurtma yetkazildi',
      ready_description: 'Yoqimli ishtaha'
    },
    cartPayment: {
      addCard: "Karta qo’shish",
      addCardPlaceholder: "Karta qo’shish",
      expiryPlaceholder: 'OO/YY',
      pay: "To’lash",
      savedCardAria: 'Karta {pan}',
      orDivider: 'YOKI',
      addCardFailed: "Kartani qo’shib bo’lmadi",
      invalidCardNumber: 'Karta raqami noto‘g‘ri',
      invalidCardExpiry: 'Karta amal qilish muddati noto‘g‘ri'
    },
    cartComment: {
      title: 'Restoranga izoh',
      placeholder: 'Buyurtma bo‘yicha istaklar, allergiyalar va h.k.',
      done: 'Tayyor'
    },
    cartHeader: {
      backToMenuAria: 'Menyuga qaytish',
      clearCartAria: 'Savatchani tozalash'
    },
    cartActions: {
      addMore: 'Yana taom qo‘shish'
    },
    cardAddFlow: {
      verifyTitle: 'Kartani tasdiqlash',
      verifyHint: 'SMS dagi 6 xonali kodni kiriting',
      confirm: 'Tasdiqlash',
      addTitle: 'Karta qo‘shish',
      addHint: 'Karta raqami va amal qilish muddatini kiriting',
      cardNumberPlaceholder: 'Karta raqami'
    },
    check: {
      yourBill: 'Hisobingiz',
      billNumber: 'Hisob №{n}',
      waiter: 'Ofitsiant',
      tableNumber: 'Stol raqami',
      tableLabel: '{n}-stol',
      tipsHeading: 'Ofitsiantga choychaqa',
      noTip: 'Choychaqasiz',
      saveTipNext: 'Keyingi buyurtma uchun choychaqa miqdorini saqlash',
      paymentMethod: 'To‘lov usuli',
      summaryHeading: 'Umumiy maʼlumot',
      rowOrder: 'Buyurtma',
      rowTips: 'Choychaqa',
      total: 'Jami',
      continue: 'Davom etish',
      disclaimer:
        'Rachmat siz, muassasa va yetkazib berish xizmati o‘rtasida vositachi bo‘lib xizmat qiladi. Tasdiqlash orqali siz Foydalanish shartlarimizni qabul qilasiz va buyurtmani qayta ishlashga ruxsat berasiz.',
      demoRestaurant: 'Osiyo oshxonasi restorani',
      demoWaiter: 'Azamat',
      demoTableNumber: '5'
    },
    orderPaymentOtp: {
      title: "To’lovni tasdiqlash",
      hint: 'SMS dagi kodni kiriting',
      confirm: 'Tasdiqlash',
      resendFailed: "Kodni qayta yuborib bo’lmadi",
      resendSent: 'Kod qayta yuborildi',
      missingCardToken: "Karta tokeni topilmadi, kodni qayta yuborib bo’lmaydi",
      cardConfirmed: "Karta muvaffaqiyatli qo’shildi",
      confirmFailed: "Noto’g’ri kod yoki karta muddati tugagan"
    },
    confirmClearCart: {
      message: "O’tgan safardagi savatchani tozalashni xohlaysizmi?",
      header: 'Savatchani tozalash',
      cancel: 'Bekor qilish',
      accept: 'Tozalash'
    },
    confirmPaymentFailed: "To’lovni tasdiqlab bo’lmadi",
    restaurantClosed: {
      title: 'Restoran vaqtincha yopiq',
      description: "Hozirda restoran buyurtma qabul qilmayapti. Biroz kutib, qayta urinib ko’ring.",
      retry: 'Qayta urinish'
    },
    confirmPaymentOtpFailed: "Noto’g’ri kod yoki to’lov tasdiqlanmadi",
    auth: {
      welcome: 'Xush kelibsiz',
      phoneIntro: 'Telefon raqamingizdan boshlaymiz',
      phoneLabel: 'Telefon raqami',
      smsTitle: 'SMS kodi',
      smsHintLine1: 'Yuborgan 4 xonali kodni kiriting',
      smsHintLine2: '{phone} raqamiga SMS orqali',
      resendPrefix: 'Qayta yuborish',
      sendAgain: 'Yuborish',
      getSmsCode: 'SMS kod olish',
      signIn: 'Kirish',
      termsLine1: 'Hisob yaratish orqali siz avtomatik ravishda Foydalanish shartlarimizni qabul qilasiz,',
      termsPrivacy: 'Maxfiylik siyosati',
      termsAnd: 'va',
      termsCookie: 'Cookie siyosati.'
    }
  },
  toast: {
    success: 'Muvaffaqiyatli',
    error: 'Xatolik',
    loginCopied: 'Login copied',
    passwordCopied: 'Password copied',
    productUnavailableSummary: 'Mahsulot mavjud emas',
    productUnavailableDetail: 'Mahsulot vaqtincha yo‘q'
  },
  redirectWindow: {
    openButton: "To'lovga o'tish ekrani",
    continueTo: "{system} ilovasida to'lov",
    redirectHint:
      "Tranzaksiyani tasdiqlash uchun {system} ilovasiga yo‘naltirilasiz",
    cancelPayment: "Bekor qilish"
  }
}
